import { render, staticRenderFns } from "./PointDialog.vue?vue&type=template&id=e844d664&scoped=true"
import script from "./PointDialog.vue?vue&type=script&lang=js"
export * from "./PointDialog.vue?vue&type=script&lang=js"
import style0 from "./PointDialog.vue?vue&type=style&index=0&id=e844d664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e844d664",
  null
  
)

export default component.exports